module.exports = __webpack_public_path__ + "static/media/client-jitta.3a1e4b8f.png";